export function objectMap<P extends string, V, U>(
  input: Record<P, V>,
  map: (key: P, value: V) => U,
) {
  const result: Partial<Record<P, U>> = {};
  for (const [key, value] of Object.entries(input)) {
    result[key as P] = map(key as P, value as V);
  }
  return result as Record<P, U>;
}
